import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "page-container",
  id: "projects-container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-44" }, null, -1)
const _hoisted_3 = { class: "project-filter font-1 text-lg list-[circle] list-inside md:flex max-w-[1600px] mb-10 mx-auto px-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "projectloader mb-10 w-0 border-t-[#979797]" }, null, -1)
const _hoisted_5 = { class: "mb-20 sm:mb-32 max-w-[1600px] mx-auto px-5" }
const _hoisted_6 = {
  id: "projectgrid",
  class: "cvolumns-1 gap-2 sm:columns-2 sm:gap-4 md:columns-3 lg:columns-3"
}
const _hoisted_7 = { class: "w-full h-full relative mb-4 overflow-hidden" }
const _hoisted_8 = {
  key: 0,
  class: "image",
  style: {"filter":"grayscale()"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "w-full h-full h-[300px] keep-all bg-black block p-10 flex items-center justify-center"
}
const _hoisted_11 = { class: "font1 text-white opacity-50" }
const _hoisted_12 = { class: "w-full h-full relative mb-4 overflow-hidden" }
const _hoisted_13 = { class: "item-backdrop w-full h-full absolute z-10 p-5 flex flex-col justify-end bg-gradient-to-t from-[#111111]/50 to-50% to-[#111111]/10" }
const _hoisted_14 = {
  key: 0,
  class: "subtitle font1 text-sm text-white drop-shadow-2xl opacity-1 block md:opacity-0 translate-y-[0] md:translate-y-[30px]"
}
const _hoisted_15 = { class: "title font2 text-3xl text-white drop-shadow-2xl opacity-1 block md:opacity-0 translate-y-[0] md:translate-y-[30px]" }
const _hoisted_16 = {
  key: 0,
  class: "image",
  style: {"filter":"grayscale()"}
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 1,
  class: "w-full h-full h-[300px] keep-all bg-black block p-10 flex items-center justify-center"
}
const _hoisted_19 = { class: "font1 text-white opacity-50" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  id: "morefollow",
  class: "font1 block text-center mt-20 px-5",
  style: {"opacity":"0"}
}, "more projects to follow", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/projects/investments",
          class: "p-2 mr-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Investments")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/projects/developments",
          class: "p-2 mr-5"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Developments")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          to: "/projects/loans",
          class: "p-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Loans")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectitems, (projectitem) => {
          return (_openBlock(), _createElementBlock("div", {
            key: projectitem.id,
            class: _normalizeClass(["col-span-2", $data.uniqueClassNames[projectitem.id % $data.uniqueClassNames.length]])
          }, [
            (_ctx.$route.params.projectCategory === 'loans')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ani-top",
                  onMouseenter: _cache[0] || (_cache[0] = ($event: any) => ($options.animateProject(true, $event))),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($options.animateProject(false, $event)))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (projectitem._embedded?.['wp:featuredmedia'] && projectitem._embedded['wp:featuredmedia'].length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("img", {
                            class: "object-cover w-full h-full",
                            src: projectitem._embedded?.['wp:featuredmedia']?.[0]?.source_url
                          }, null, 8, _hoisted_9)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("h3", _hoisted_11, _toDisplayString($setup.decodeEntities(projectitem.title.rendered)) + " image coming soon", 1)
                        ]))
                  ])
                ], 32))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: '/project/'+projectitem.slug,
                  class: "ani-top",
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => ($options.animateProject(true, $event))),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => ($options.animateProject(false, $event)))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (projectitem.ACF.location)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString($setup.decodeEntities(projectitem?.ACF?.location)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("h2", _hoisted_15, _toDisplayString($setup.decodeEntities(projectitem.title.rendered)), 1)
                      ]),
                      (projectitem._embedded?.['wp:featuredmedia'] && projectitem._embedded['wp:featuredmedia'].length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("img", {
                              class: "object-cover w-full h-full",
                              src: projectitem._embedded?.['wp:featuredmedia']?.[0]?.source_url
                            }, null, 8, _hoisted_17)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("h3", _hoisted_19, _toDisplayString($setup.decodeEntities(projectitem.title.rendered)) + " image coming soon", 1)
                          ]))
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
          ], 2))
        }), 128))
      ]),
      _hoisted_20
    ])
  ]))
}